import { getUnMatchedBetsError, getUnMatchedBetsSuccess } from "./unMatchedBets.slice";
import getErrorMessage from "../../helpers/getErrorMessage.helper";
import http from "../../services/httpAuth";

export const requestUnMatchedBets = (eventId, sportId) => async (dispatch, getState) => {
    const auth = getState().auth;
    let data = {
        limit: 100,
        page: 1,
        search: sportId == 7 || sportId == 4339 ? {
            delete_status: 0,
            market_id: eventId
        } :{
            delete_status: 0,
            match_id: eventId
        }
    }
    if (auth) {
        try {
            // const userId = getState().user.memberCode;
            // const eventParam = eventId ? `&eventId=${eventId}` : "";
            const response = await http.post(`/bet/unmatchedBets`, data);
            if (response.data.status) {
                dispatch(getUnMatchedBetsSuccess(response.data.data[0]?.data));
            }
            return response;
        } catch (e) {
            dispatch(getUnMatchedBetsError());
            const errorMsg = getErrorMessage(e);
            throw errorMsg;
        }
    }
};

export const requestUnMatchedBetsWithDate = (from, to, eventId) => async (dispatch, getState) => {
    try {
        const data = {
            limit: 150,
            search: {},
            from_date: from,
            to_date: to
        }
        const response = await http.post(`/bet/unmatchedBets`, data);
        if (response.data.status) {
            dispatch(getUnMatchedBetsSuccess(response?.data?.data[0]?.data));
        }
        return response;
    } catch (e) {
        dispatch(getUnMatchedBetsError());
        const errorMsg = getErrorMessage(e);
        throw errorMsg;
    }
};

export const requestPastBets = (from, to, eventId) => async (dispatch, getState) => {
    try {
        const data = {
            page: 1,
            limit: 150,
            search: {},
            from_date: from,
            to_date: to
        }
        const response = await http.post(`/bet/settledBets`, data);
        // if (response.data.success) {
        //     dispatch(getOpenBetsSuccess(response.data.result));
        // }
        return response;
    } catch (e) {
        dispatch(getUnMatchedBetsError());
        const errorMsg = getErrorMessage(e);
        throw errorMsg;
    }
};
